export const globalConstants = {
  generic: {
    cookieKey: "DRIRESTAURANTID",
    API_CACHE_TIME: 300, //TIME IN SECONDS
    LOCAL_STORAGE_KEY: "DRIRESTAURANTGROUP",
    privacyText: ['cookie preference', 'privacy choice'],
    CTA: {
      footer: 'footer|',
      header: 'header|',
      postText: 'cta'
    },
    new_locations_image: {
      olivegarden: 'https://media.olivegarden.com/en_us/images/product/OG_NRO_Location.jpg',
      eddiev: 'https://media.eddiev.com/en_us/images/marketing/m-eddie-v-8513-orlando-fl-160x165.jpg',
      longhornsteakhouse: 'https://media.longhornsteakhouse.com/images/site/lh_front.jpg',
      thecapitalgrille:'https://media.thecapitalgrille.com/images/site/TCG-8001-Providence-RI-Ext-160x165.jpg',
      thecapitalburger:'https://media.thecapitalburger.com/en_us/images/marketing/bacon-cheeseburger-160x165.jpg',      
      seasons52: 'https://media.seasons52.com/en_us/images/marketing/seasons52-4525-birmingham-al-d-599x430.jpg',
      yardhouse: 'https://media.yardhouse.com/en_us/images/marketing/raleigh-nc-yard-house-599x430.jpg.jpg',
      chuys:'https://media.chuys.com/images/site/pages/new-locations/chy-new-locations-restaurant-front.jpg',
      ruthschris:'https://media.ruthschris.com/images/site/ext/images/rc-new-location-coming-soon.jpg',
      cheddars:'https://media.cheddars.com/images/site/pages/pdc/csk-pdc-location-featured.jpg',
    },
    API_URLS: {
      RESTAURANTS_URL: '/api/restaurants?locale=en_US',
    },
  },
  eddiev: {
    HEADER_TEXT: {
      MAKE_RESERVATION: "Make a Reservation",
      SKIP_CONTENT: "Skip to content",
      CART: "Cart",
      CART_COUNT: "0",
      ITEMS: "items in cart",
    },
    IMAGES: {
      WHITE_DOWN_ARROW: {
        IMAGE_URL:
          "//media.eddiev.com/images/site/responsive/global/white-down-arrow.svg",
        IMAGE_ALT: "dropdown location arrow",
      },
      LOCATION_DETAILS_PIN: {
        IMAGE_URL:
          "//media.eddiev.com/images/site/responsive/global/location-details-pin.svg",
        IMAGE_ALT: "",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.eddiev.com/en_us/images/marketing/m-eddie-v-8513-orlando-fl-160x165.jpg",
        IMAGE_ALT: "Marketing",
      },
    },
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag.",
    },
  },
  thecapitalgrille: {
    HEADER_TEXT: {
      WELCOME: "Welcome",
      NEAREST_LOCATION_MESSAGE: "is your nearest",
      BRAND_NAME: "Capital Grille",
      BASED_ON_LOCATION: "based on your current location.",
      CHOOSE_NEW_LOCATION: "CHOOSE NEW LOCATION",
      CART_COUNT: "0",
    },
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag. Please enjoy our elegant dining experience by visiting us in person.",
      VIDEO_DESCRIPTION: "Decorative background video showing The Capital Grille's elegant dining atmosphere, featuring sophisticated table settings and ambiance. This video is for visual enhancement only and does not contain essential information.",
      TITLE: "Capital Hours",
      SCROLL: "Scroll",
      SCROLL_TEXT: 'to restaurant features'
    },
    IMAGES: {
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.thecapitalgrille.com/images/site/page-updates/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.thecapitalgrille.com/images/site/TCG-8001-Providence-RI-Ext-160x165.jpg",
        IMAGE_ALT: "Location",
      },

    },
  },
  thecapitalburger: {
    HEADER_TEXT: {
      WELCOME: "Welcome",
      NEAREST_LOCATION_MESSAGE: "is your nearest",
      BRAND_NAME: "The Capital Burger",
      BASED_ON_LOCATION: "based on your current location.",
      CHOOSE_NEW_LOCATION: "CHOOSE NEW LOCATION",
      CART: "Cart",
      CART_COUNT: "0",
      CLICK_HERE: "Click here to see our",
      DINE_IN_MENU: "dine in menu",
    },
    IMAGES: {
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.thecapitalburger.com/images/site/page-updates/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.thecapitalburger.com/en_us/images/marketing/bacon-cheeseburger-160x165.jpg",
        IMAGE_ALT: "Location",
      },
    },
  },
  seasons52: {
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag.",
    },
    HEADER_TEXT: {
      CART: "Cart",
      CART_COUNT: "0",
    },
    CAROUSEL_TEXT: {
      FEATURED_PROMOTIONS: "Featured Promotions",
    },
    IMAGES: {
      LOCATION_ICON: {
        IMAGE_URL:
          "https://media.seasons52.com/images/site/responsive/locate-icon.png",
        IMAGE_ALT: "locate",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.seasons52.com/images/site/S52-4501-Orlando-FL-ext-07-160x165.jpg",
        IMAGE_ALT: "Seasons 52 Restaurant Location",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.bahamabreeze.com/images/site/ext/page-updates/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
      PAUSE_ICON: {
        IMAGE_URL:
          "https://media.seasons52.com/images/site/page-updates/icons/pause.svg",
        IMAGE_ALT: "Pause Icon",
      },
    },
  },
  chuys: {
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support videos.",
    },
    FOOTER_TEXT: {
      BACK_TO_TOP: "Back to top",
    },
    IMAGES: {
      HAMBURGER_ICON: {
        IMAGE_URL:
          "https://media.chuys.com/images/site/global/header/chy-header-hamburger-btn.svg",
        IMAGE_ALT: "hamburger",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.bahamabreeze.com/images/site/ext/page-updates/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
    },
    ECLUB_TEXT: {
      SUB_SIGN_UP: "Email subscription signup",
      SIGN_UP_TITLE: "It's official!",
      SIGN_UP_MSG:
        "Thanks for signing up. You just joined the coolest club in Tex-Mex.| Keep an eye out for mouthwatering updates and eClub exclusives.",
    },
  },
  ruthschris: {
    IMAGES: {
      HAMBURGER_ICON: {
        IMAGE_URL: "https://media.ruthschris.com/images/assets/hamBurger.svg",
        IMAGE_ALT: "hamburger",
      },
      LOCATION_ICON: {
        IMAGE_URL: "https://media.ruthschris.com/images/assets/location.svg",
        IMAGE_ALT: "location",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.yardhouse.com/images/site/ext/icons/privacy-choices-icon.png",
        IMAGE_ALT: "privacy choices icon",
      },
      BACK_TO_TOP_ICON: {
        IMAGE_URL:
          "https://media.ruthschris.com/images/assets/backToTopButton.svg",
        IMAGE_ALT: "Back to Top",
      },
    },
    LINKS: {
      FOOTER_NOTE: {
        HREF: "https://www.darden.com/",
        TITLE: "",
        DATA_LINK_INFO: "darden-cta",
        TARGET: "_blank",
      },
    },
  },
  yardhouse: {
    HEADER_TEXT: {
      WELCOME: "Welcome",
      NEAREST_LOCATION_MESSAGE: "is your nearest",
      BRAND_NAME: "Yard House",
      BASED_ON_LOCATION: "based on your current location.",
      CHOOSE_NEW_LOCATION: "CHOOSE NEW LOCATION",
      CART: "Cart",
      CART_COUNT: "0",
      CLICK_HERE: "Click here to see our",
      DINE_IN_MENU: "dine in menu",
    },
    IMAGES: {
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.yardhouse.com/en_us/images/marketing/yard-house-160x165.jpg",
        IMAGE_ALT: "Yard House Restaurant Location",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.yardhouse.com/images/site/ext/icons/privacy-choices-icon.png",
        IMAGE_ALT: "privacy choices icon",
      },
    },
  },
  cheddars: {
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag.",
    },
    HEADER_TEXT: {
      CART: "items in cart",
      CART_COUNT: "0",
    },
  },
  longhornsteakhouse: {
    HEADER_TEXT: {
      SKIP_CONTENT: "Skip to content",
      CART: "Cart",
      CART_COUNT: "0",
      ITEMS: "items in cart",
      HIDDEN_LOCATION: "Change or Find location",
    },
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag.",
    },
    ECLUB_TEXT: {
      SIGN_UP_MSG: "You have signed up successfully!",
      SIGN_UP_TITLE: "Welcome to the LongHorn eClub.",
    },
    CAROUSEL_TEXT: {
      START_INDEX: 1,
    },
    IMAGES: {
      CLOSE_CART: {
        IMAGE_URL:
          "//media.longhornsteakhouse.com/images/site/responsive/global/close-icon-black.svg",
        IMAGE_ALT: "Close Cart Popup",
      },
      MAP_LOCATION_PIN: {
        IMAGE_URL:
          "//media.longhornsteakhouse.com/images/site/responsive/global/map-location-pin-dark.svg",
        IMAGE_ALT: "",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.longhornsteakhouse.com/images/site/ext/pages/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
      SCROLL_INDICATOR: {
        IMAGE_URL:
          "https://media.longhornsteakhouse.com/images/site/ext/pages/home/lh-home-scroll-arrow-indicator.svg",
        IMAGE_ALT: "Scroll Down",
        DATA_LINK_INFO: "scroll-down-cta",
      },
      VIDEO_POSTER: {
        IMAGE_URL:
          "https://media.longhornsteakhouse.com/images/site/ext/pages/home/lh-home-plate-of-asparagus.png",
        ARIA_LABEL: "LongHorn Steakhouse hero video featuring food preparation",
      },
    },
  },
  bahamabreeze: {
    VIDEO_BANNER_TEXT: {
      VIDEO_SUPPORT_TAG: "Your browser does not support the video tag.",
    },
    ECLUB_TEXT: {
      SUCCESS_TEXT: "eClub Signup Success",
    },
    HEADER_TEXT: {
      WELCOME: "Welcome",
      NEAREST_LOCATION_MESSAGE: "is your nearest",
      BRAND_NAME: "Bahama Breeze",
      BASED_ON_LOCATION: "based on your current location.",
      CHOOSE_NEW_LOCATION: "CHOOSE NEW LOCATION",
      CART: "Cart",
      CART_COUNT: "0",
      CLICK_HERE: "Click here to see our",
      DINE_IN_MENU: "dine in menu",
      CART: "items in cart",
      CART_COUNT: "0",
    },
    IMAGES: {
      LOCATION_ICON: {
        IMAGE_URL:
          "https://media.bahamabreeze.com/images/site/ext/responsive/locate-icon.png",
        IMAGE_ALT: "locate",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.bahamabreeze.com/en_us/images/marketing/seattle-wa-bahama-breeze-160x165.jpg",
        IMAGE_ALT: "Bahama Breeze Restaurant Location",
      },
      PRIVACY_ICON: {
        IMAGE_URL:
          "https://media.bahamabreeze.com/images/site/ext/page-updates/icons/privacy-icon-45w.png",
        IMAGE_ALT: "privacy choices icon",
      },
    },
  },
  olivegarden: {
    privacyText: ['cookie preference'],
    INFO_ICON_SVG: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5.33333C8.36819 5.33333 8.66667 5.63181 8.66667 6V8C8.66667 8.36819 8.36819 8.66667 8 8.66667C7.63181 8.66667 7.33333 8.36819 7.33333 8V6C7.33333 5.63181 7.63181 5.33333 8 5.33333Z" fill="black" />
      <path d="M8.66667 10C8.66667 10.3682 8.36819 10.6667 8 10.6667C7.63181 10.6667 7.33333 10.3682 7.33333 10C7.33333 9.63181 7.63181 9.33333 8 9.33333C8.36819 9.33333 8.66667 9.63181 8.66667 10Z" fill="black" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM12.6667 8C12.6667 10.5773 10.5773 12.6667 8 12.6667C5.42267 12.6667 3.33333 10.5773 3.33333 8C3.33333 5.42267 5.42267 3.33333 8 3.33333C10.5773 3.33333 12.6667 5.42267 12.6667 8Z" fill="black" />
    </svg>,
    IMAGES: {
      CLOSE_ICON: {
        IMAGE_URL: "https://media.olivegarden.com/images/OG_Redesign_Assets/Plus.svg",
        IMAGE_ALT: "Cross Icon",
      },
      CART_ICON: {
        IMAGE_URL: "https://media.olivegarden.com/images/OG_Redesign_Assets/Mobile/Icons/Mobile_Header_Cart.svg",
        IMAGE_ALT: "Cart Icon",
      },
      LOGO_IMAGE: {
        IMAGE_URL: " https://media.olivegarden.com/images/OG_Redesign_Assets/OG_Logo.svg",
        IMAGE_ALT: "Olive Garden Logo",
      },
      LOCATION_ICON: {
        IMAGE_URL: "https://media.olivegarden.com/images/OG_Redesign_Assets/Mobile/Icons/Mobile_Header_Location.svg",
        IMAGE_ALT: "Location Icon",
      },
      CHEVRON_RIGHT: {
        IMAGE_URL: "https://media.olivegarden.com/images/OG_Redesign_Assets/Icons/Menu_Detail_Chevron_Right.svg",
        IMAGE_ALT: "Chevron Right Icon",
      },
      TIRAMISU_ICON: {
        IMAGE_URL: "https://media.olivegarden.com/images/OG_Redesign_Assets/Mobile/Mobile_Hamburger_Menu_Illustration.png",
        IMAGE_ALT: "Tiramisu Icon",
      },
      MOBILE_DROPDOWN_MARKETING: {
        IMAGE_URL:
          "https://media.olivegarden.com/en_us/images/marketing/italian-family-restaurant-olive-garden-g6-r1x1.jpg",
        IMAGE_ALT: "Olive Garden Restaurant Location",
      },


    },
  },
};

export const errorConstants = {
  GENERIC_PAGE_FETCH_ERROR: "Error fetching generic page data.",
  GLOBAL_SETTINGS_FETCH_ERROR: "Error fetching global settings data.",
  PAGE_NOT_FOUND: "The requested page was not found.",
  PAGE_FETCH_EROR: "Error fetching page",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  TRY_AGAIN_LATER: "Please try again later.",
  ERR_FETCH_LAYOUT: "Error fetching page in Layout:",
  ERR_HEADER_FOOTER: "Error fetching Header Footer data for brand:",
  ERR_LOAD_PERSONALIZE: "Failed to load Personalize",
  RESTAURANTS_API_ERROR: "Error fetching restaurants from API",
  RESTAURANTS_API_CONFIG_ERROR: "Restaurants API URL is not configured",
  RESTAURANTS_INVALID_RESPONSE: "Invalid restaurants API response format",
  RESTAURANTS_FETCH_FAILED: "Failed to fetch restaurants data",
};


export const eclubInputConstants = {
  eddiev: {
    localjvmname: "darden-app-04",
    conceptCode: 'EV',
    mediaPath: 'https://media.eddiev.com/images/site',
    signupSource: 'ev_signup_fw_footer',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  thecapitalgrille: {
    localjvmname: "darden-app-02",
    conceptCode: 'CG',
    signupSource: 'cg_signup_homepage',
    reservationSignupSource: 'cg_reservations',
    mediaPath: 'https://media.thecapitalgrille.com/images/site',
  },
  thecapitalburger: {
    localjvmname: "darden-app-03",
    conceptCode: 'CB',
    mediaPath: 'https://media.thecapitalburger.com/images/site',
    signupSource: 'cb_signup_fw_footer',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  seasons52: {
    localjvmname: "darden-app-04",
    conceptCode: 'S52',
    mediaPath: 'https://media.seasons52.com/images/site',
    signupSource: '52_signup_homepage',
    reservationSignupSource: '52_reservations',
  },
  chuys: {
    localjvmname: "darden-app-02",
    conceptCode: 'CH',
    mediaPath: 'https://media.chuys.com/images/site',
    signupSource: 'ch_signup_homepage',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  longhornsteakhouse: {
    localjvmname: "darden-app-04",
    conceptCode: 'LH',
    mediaPath: 'https://media.longhornsteakhouse.com/images/site',
    signupSource: 'home_crm_signup_source',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  cheddars: {
    localjvmname: "darden-app-02",
    conceptCode: 'CS',
    mediaPath: 'https://media.cheddars.com/images/site',
    signupSource: 'cs_signup_homepage',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  yardhouse: {
    localjvmname: "darden-app-03",
    conceptCode: 'YH',
    mediaPath: 'https://media.yardhouse.com/images/site',
    signupSource: 'yh_signup_homepage',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },
  ruthschris: {
    localjvmname: "darden-app-04",
    conceptCode: 'RC',
    mediaPath: 'https://media.ruthschris.com/images/site',
    signupSource: 'rc_signup_homepage',
    reservationSignupSource: 'rc_reservations',
  },
  bahamabreeze: {
    localjvmname: "darden-app-01",
    conceptCode: 'BB',
    mediaPath: 'https://media.bahamabreeze.com/images/site',
    signupSource: 'bb_signup_homepage',
    reservationSignupSource: '???reservation_crm_signup_source???',
  },



}


export const locationConstants = {
  LOADING_MESSAGE: "Loading locations...",
  NO_LOCATIONS_MESSAGE: "No new locations available at this time.",
}


export const routesWithoutHeaderFooterConfig = [
  '/reservations',
  '/private-dining/make-a-request',
  '/private-events/make-a-request',
  '/group-dining/make-a-request',
];